/**
 * Sa.Reseller.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type CompanySearchFilterSegaStatus = 'None' | 'Active' | 'Expired';

export const CompanySearchFilterSegaStatus = {
    None: 'None' as CompanySearchFilterSegaStatus,
    Active: 'Active' as CompanySearchFilterSegaStatus,
    Expired: 'Expired' as CompanySearchFilterSegaStatus
};

